<div class="row row-sm add-form min" [formGroup]="PayLateForm">
    <div class="col-lg-12 ">
        <div class="card-body">
            <div class="bc d-flex align-items-center pl-3">
                <div class="ml-2">
                    <h3 class="main-content-label mb1"><b>
                            Students With Exam Fees
                        </b></h3>
                </div>
            </div>
 
            <div class="row row-sm add-form mt-3">
                <!-- <h6>{{data.data.ReRgId}} {{data.data.RgName}}</h6> -->
                <div class="col-sm-12 pl-0">
                    <div>
                        <div class="table-responsive table-container" id="table">
                            <table class="table table-bordered text-nowrap">
                                <thead>
                                    <tr class="text-left">
                                        <th class="f600">
                                            Name
                                        </th>
                                        <th class="f600">
                                            Template Code
                                        </th>
                                        <th class="f600">
                                            Fees Status
                                        </th>
                                        <th class="f600">
                                            Pay Later
                                        </th>
                                        <th class="f600 hidden">
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="curs"  formArrayName="PayLateGrid">
                                    <!-- *ngFor="let item of examData" [class.selected-row]="item === selectedRow" (click)="selected(item)" -->
                                    <tr *ngFor="let item of getPayLateGridControls();let last =last; let i = index"
                                    [formGroupName]="i">
                                        <td><input formControlName="name" readonly class="form-control input-sm"></td>
                                        <td><input formControlName="TemplateCode" readonly class="form-control input-sm"></td>
                                        <td>
                                            <input formControlName="TotalPaidAmount" readonly class="form-control input-sm">
                                        </td>
                                        <td>
                                            <input formControlName="FeeStatus" type="checkbox" 
                                            [checked]="PayLateForm.get('PayLateGrid.' + i + '.FeeStatus').value === 'Y' || PayLateForm.get('PayLateGrid.' + i + '.FeeStatus').value === 'N'"
                                            [attr.disabled]="PayLateForm.get('PayLateGrid.' + i + '.TotalPaidAmount').value === 'Paid' ? true : null"
                                            (change)="onCheckboxChange($event.target.checked, i)" />
                                        </td>
                                        <td class="hidden">
                                            <input formControlName="Status">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
 
                    </div>
                    <div class="col-sm-4">
                        <button type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                        <button type="button" (click)="Save()"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
                                Save
                            </span>
                        </button>
                    </div>
                </div>
 
            </div>
        </div>
    </div>
</div>
